import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import {
  ReportsActionTypes,
  GetReportsSuccess,
  GetReportSuccess
} from '../../actions/reports/reports.actions';
import {exhaustMap, map, switchMap, tap} from 'rxjs/operators';
import { ReportsService } from '../../services/reports/reports.service';

@Injectable()
export class ReportsEffects {
  @Effect()
  public getReports() {
    return this.actions.pipe(
      ofType(ReportsActionTypes.GET_REPORTS),
      exhaustMap((action: any) => {
        return this.reportsService.getReports(action.paging).pipe(
          map(response =>
            GetReportsSuccess({
              reports: response.results.map(item => ({
                id: item.id,
                title: item.name,
                description: item.description,
                date: item.creation_time,
                tags: [],
                attachments: item.attachments,
                url: 'dashboard/reporting/'
              })),
              totalCount: response.totalcount
            })
          )
        );
      })
    );
  }

  @Effect()
  public getReport() {
    return this.actions.pipe(
      ofType(ReportsActionTypes.GET_REPORT),
      tap((action: any) => {
        this.reportsService.getReport(action.id);
      })
    );
  }

  constructor(
    private actions: Actions,
    private reportsService: ReportsService,
  ) {}
}
